/**
 * The reading panel's copy (ADR-077): the name a screen reader gives the dialog, its buttons' labels and the page
 * counter's line, `{page}` of `{count}` pages. Drafts for the author, shown at `/ui?page=reading`.
 */
export const READING = {
  label: "Sign",
  close: "Close",
  back: "Back",
  next: "Next",
  pageOf: "Page {page} of {count}",
} as const;
